<picture>
    <source srcset="/assets/images/login-mobile-img.png" media="(max-width: 576px)" />
    <source srcset="/assets/images/login-img.png" media="(min-width: 577px)" />

    <img class="w-full" src="/assets/images/login-img.png" alt="" />
</picture>
